// components/FormTextField.tsx
"use client";

import * as React from "react";
import FormControl from "@mui/joy/FormControl";
import FormLabel from "@mui/joy/FormLabel";
import { Textarea as JoyTextarea, Typography } from "@mui/joy";
import { Controller, useFormContext } from "react-hook-form";

const Textarea: React.FC<any> = ({
    name,
    label,
    placeholder,
    rules = {},
    type = "text",
    helperText,
    size = "md",
    ...props
}) => {
    const { control } = useFormContext();
    return (
        <Controller
            name={name}
            control={control}
            rules={rules}
            render={({ field, fieldState }) => (
                <FormControl error={!!fieldState.error} size={size}>
                    <FormLabel>{label}</FormLabel>
                    {helperText && !fieldState.error && (
                        <Typography level="body-xs" sx={{ color: "text.secondary", mb: 1, mt: -0.7 }}>
                            {helperText}
                        </Typography>
                    )}
                    {fieldState.error && (
                        <Typography level="body-xs" color="danger" sx={{ mb: 1, mt: -0.7 }}>
                            {fieldState.error.message}
                        </Typography>
                    )}
                    <JoyTextarea {...field} minRows={3} placeholder={placeholder} type={type} {...props} />
                </FormControl>
            )}
        />
    );
};

export default Textarea;
